import api from './api';

export interface TimezoneResponse {
  tz_identifier: string;
  utc_offset: string | null;
  abbreviation: string | null;
  is_dst: boolean;
}

class TimezoneService {
  /**
   * Get timezone information for coordinates
   */
  async getTimezone(lat: number, lng: number): Promise<TimezoneResponse> {
    const response = await api.get('/timezone', {
      params: { lat, lng }
    });
    return response.data;
  }
}

export const timezoneService = new TimezoneService();
export default timezoneService;
